import { useIntl } from "react-intl";

import { PersistentDrawer } from "@/components/Drawer/PersistentDrawer";

type Props = {
  travellersSelected: number;
  travellersToSelect: number;
};

export function TravellerSelectionStatusDrawer({
  travellersSelected,
  travellersToSelect,
}: Props) {
  const intl = useIntl();

  return (
    <PersistentDrawer
      shouldNotTrackHeight
      noShadow
      noBorder
      borderRadius="var(--radius-2xl)"
    >
      <div
        style={{
          paddingTop: "calc(var(--spacing) * 2)",
          paddingBottom: "calc(var(--drawer-height, 0) + var(--spacing) * 2)",
          backgroundColor:
            travellersSelected === travellersToSelect
              ? "var(--color-surface-accent-soft)"
              : "var(--color-surface-neutral-medium)",
        }}
        className="-m-6"
      >
        <p className="text-center text-sm">
          {intl.formatMessage(
            {
              defaultMessage: "{selectedCount} of {totalCount} selected",
              description:
                "Summary of how many travellers have been assigned out of the total",
            },
            {
              selectedCount: travellersSelected,
              totalCount: travellersToSelect,
            },
          )}
        </p>
      </div>
    </PersistentDrawer>
  );
}
